import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Adjust the imports based on your setup
import { Button, Dropdown } from "react-bootstrap";
import UserInfo from "../../Hooks/UserInfo";
import { schoolCsvListAction } from "../../Redux/Action/schoolAction";
import { useDispatch } from "react-redux";
import PersistSearch from "../../Util/PersistSearch";
import DatePicker from "react-datepicker";
import { dropdownGroupsDashboard } from "../../constant/StaticData";
import { FaTimes } from "react-icons/fa";
const FilterIcon = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.75 4.08342C1.75 2.95583 2.66408 2.04175 3.79167 2.04175C4.91925 2.04175 5.83333 2.95583 5.83333 4.08342C5.83333 5.211 4.91925 6.12508 3.79167 6.12508C2.66408 6.12508 1.75 5.211 1.75 4.08342ZM11.6667 4.66675H7V3.50008H11.6667V4.66675ZM8.16667 9.91675C8.16667 8.78917 9.08075 7.87508 10.2083 7.87508C11.3359 7.87508 12.25 8.78917 12.25 9.91675C12.25 11.0443 11.3359 11.9584 10.2083 11.9584C9.08075 11.9584 8.16667 11.0443 8.16667 9.91675ZM7 9.33342V10.5001H2.33333V9.33342H7Z"
      fill="#2B3674"
    />
  </svg>
));
const RightTopSection = ({
  breadcrumb,
  title,
  onCreateClick,
  bellLink,
  userImage,
  type,
  setSearchValue,
  setSelectedSchoolId,
  selectedSchoolId,
  selectedFilterDateRange,
  handleFilterDateRangeChange,
  handleSelectForCategory,
  selectedClassForCategory,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    userInfo,
    contentPermission,
    schoolDetailPermission,
    faqPermission,
    notificationPermission,
    adminPermission,
  } = UserInfo();
  const [schoolCsvList, setSchoolCsvList] = useState([]);
  // Prefetch the CSV data when the component mounts
  const fetchTeacherCsvData = async () => {
    try {
      const data = await dispatch(schoolCsvListAction());
      if (data?.payload?.statusCode === 200) {
        setSchoolCsvList(data?.payload?.data);
      } else {
        // toast.error("No Data Available to Download");
      }
    } catch (error) {
      console.error("Error in downloadTeacherCsv:", error);
    }
  };

  // Use useEffect to fetch CSV data on component mount
  useEffect(() => {
    fetchTeacherCsvData();
  }, []);

  const handleSchoolChange = (e) => {
    const schoolId = e.target.value;
    setSelectedSchoolId(schoolId);

    if (schoolId) {
      navigate(`/dashboard?schoolId=${schoolId}`);
    } else {
      navigate(`/dashboard`);
    }
  };

  return (
    <div className="right-top">
      <div className="heading-top">
        
        <h2>{title}</h2>
      </div>
      
      <div
        className={`
                ${
                  [
                    "ManagePresenters",
                    "ManageTags",
                    "manageCategories",
                    "PackRequests",
                    "Support",
                    "ChangePassword",
                  ].includes(type)
                    ? ""
                    : "user-side-pro"
                }
              `}
      >
        {type === "manageCategories" && null}
        {type === "ManageTags" && null}
        {type === "PushNotification" && null}
        {type === "AddOnPacks" && (
          <Button
            className="cursor-pointer modal-f-btn text-nowrap d-flex align-items-center gap-1"
            onClick={() => onCreateClick("create", null)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="white"
            >
              <path d="M560-320h80v-80h80v-80h-80v-80h-80v80h-80v80h80v80ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z" />
            </svg>{" "}
            Create Pack
          </Button>
        )}
        {type === "ManageContent" && <PersistSearch />}
        {type === "DashBoardHeader" && (
          <>
            <DatePicker
              selected={selectedFilterDateRange[0]}
              onChange={handleFilterDateRangeChange}
              startDate={selectedFilterDateRange[0]}
              endDate={selectedFilterDateRange[1]}
              selectsRange
              dateFormat="dd/MM/yyyy"
              showIcon
              placeholderText="Select Date Range"
              isClearable={true}
              className="calendar-filter rounded-pill border small"
              wrapperClassName="datepicker-wrapper"
              customInput={<input style={{ width: "225px" }} />}
              maxDate={new Date()} // Prevents selecting future dates
            />{" "}
            <Dropdown onSelect={handleSelectForCategory}>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                className="d-flex align-items-center border rounded-pill"
              >
                <FilterIcon />
                <p className="m-0 flex-grow-1">
                  {selectedClassForCategory || "Year Group"}
                </p>

                {selectedClassForCategory && (
                  <FaTimes
                    style={{ cursor: "pointer", marginLeft: 8 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectForCategory(null);
                    }}
                    title="Clear filter"
                  />
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {dropdownGroupsDashboard.map((group) => (
                  <React.Fragment key={group.group}>
                    <Dropdown.Item eventKey={`group-${group.group}`}>
                      {group.label}
                    </Dropdown.Item>
                    
                  </React.Fragment>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <select
              className="ad-arrow border rounded-pill py-2"
              value={selectedSchoolId}
              onChange={handleSchoolChange}
            >
              <option value="">All Schools</option>
              {Array.isArray(schoolCsvList) &&
                schoolCsvList.map((ele) => (
                  <option key={ele._id} value={ele._id}>
                    {ele.schoolName}
                  </option>
                ))}
            </select>
          </>
        )}
        {type === "AllSchools" && <PersistSearch />}
        {type === "school-stats" && <PersistSearch />}
        {type === "AllStudent" && <PersistSearch />}

        {type === "AllParents" && <PersistSearch />}
        {type === "AllTeacher" && <PersistSearch />}

        {type === "ManageAdmins" && <PersistSearch />}

        {type === "ManageContent" && (
          <div className="user-pro-ulpd content-btn">
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={onCreateClick}
              disabled={!contentPermission}
            >
              <span>
                
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  className="me-2"
                >
                  <circle cx="14.5" cy="14.5" r="14.5" fill="white" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    viewBox="0 -960 960 960"
                    fill="#1f1f1f"
                    x="4.5"
                    y="4.5"
                  >
                    <path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
                  </svg>
                </svg>
              </span>
              Upload
            </Button>
          </div>
        )}

        {type === "AllSchools" && (
          <div className="user-pro-ulpd content-btn">
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={onCreateClick}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <circle cx="14.5" cy="14.5" r="14.5" fill="white" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                    x="2.5"
                    y="2.5"
                  >
                    <path d="M700-200h40v-100h100v-40H740v-100h-40v100H600v40h100v100Zm20 80q-83 0-141.5-58.5T520-320q0-83 58.5-141.5T720-520q83 0 141.5 58.5T920-320q0 83-58.5 141.5T720-120Zm-560-80v-480l320-240 320 240v92q-19-6-39-9t-41-3v-40L480-820 240-640v360h203q3 21 9 41t15 39H160Zm320-350Z" />
                  </svg>
                </svg>{" "}
              </span>
              Create
            </Button>
          </div>
        )}

        {type === "ManageAdmins" && (
          <div className="user-pro-ulpd">
            <Button
              variant="primary"
              className="modal-f-btn text-nowrap"
              onClick={onCreateClick}
              disabled={!adminPermission}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <circle cx="14.5" cy="14.5" r="14.5" fill="white" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                    x="2.5"
                    y="2.5"
                  >
                    <path d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80ZM247-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q440-607 440-640t-23.5-56.5Q393-720 360-720t-56.5 23.5Q280-673 280-640t23.5 56.5Q327-560 360-560t56.5-23.5ZM360-640Zm0 400Z" />
                  </svg>
                </svg>{" "}
              </span>
              Create New Admin
            </Button>
          </div>
        )}

        {type === "PushNotification" && (
          <div className="user-pro-ulpd">
            <Button
              variant="primary"
              className="modal-f-btn text-nowrap w-100"
              onClick={onCreateClick}
              disabled={!notificationPermission}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  className="me-2"
                >
                  <circle cx="14.5" cy="14.5" r="14.5" fill="white" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                    x="2.5"
                    y="2.5"
                  >
                    <path d="M480-500Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Zm240-360v-120H600v-80h120v-120h80v120h120v80H800v120h-80ZM160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q14 4 27.5 8.5T593-772q-15 14-27 30.5T545-706q-15-7-31.5-10.5T480-720q-66 0-113 47t-47 113v280h320v-112q18 11 38 18t42 11v83h80v80H160Z" />
                  </svg>
                </svg>
              </span>
              Schedule Notification
            </Button>
          </div>
        )}

        {type === "faqs" && (
          <div className="user-pro-ulpd content-btn">
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={onCreateClick}
              disabled={!faqPermission}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <circle cx="14.5" cy="14.5" r="14.5" fill="white" />
                  <path
                    d="M14.466 18.4825L10 15.945L14.4654 22L18.9351 15.945L14.4642 18.4825H14.466ZM14.534 8L10.0667 15.1301L14.5334 17.6699L19 15.1324L14.534 8Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </svg>
              </span>
              Create
            </Button>
          </div>
        )}
        
        
      </div>
    </div>
  );
};

export default RightTopSection;
